<template>
    <page-table/>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'order-changeOrderConfirm',
  components: {
    PageTable,
  },
}
</script>